import React from 'react';

const MIYoutube = ({configurable}) => {
    return (
        <div className={"MIYoutube"}>
            <iframe src={`${"https://www.youtube.com/embed/" + configurable.video_id}`}
                    title="YouTube video player"
                    allow="accelerometer; encrypted-media;"
                    allowFullScreen height="315"></iframe>
        </div>
    );
};

export default MIYoutube;